import { useState } from 'react';

const WA_URL = 'https://wa.me/573228000501?text=Hola%2C%20me%20gustar%C3%ADa%20conocer%20m%C3%A1s%20sobre%20sus%20productos';

export default function FloatingWhatsApp() {
  const [dismissed, setDismissed] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {!dismissed && (
        <div className="relative bg-white text-charcoal text-xs font-sans font-medium px-4 py-2 rounded-2xl rounded-br-none border border-gray-100 whitespace-nowrap">
          ¡Escríbenos ahora! 💬
          <button
            onClick={() => setDismissed(true)}
            className="absolute -top-2 -right-2 w-5 h-5 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 transition-colors cursor-pointer"
            aria-label="Cerrar"
          >
            <i className="ri-close-line text-xs text-charcoal" />
          </button>
        </div>
      )}
      <a
        href={WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contactar por WhatsApp"
        className="relative group cursor-pointer"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
        <div className="relative w-16 h-16 bg-[#25D366] hover:bg-[#20BA5A] rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110">
          <i className="ri-whatsapp-fill text-white text-3xl group-hover:rotate-12 transition-transform duration-300" />
        </div>
      </a>
    </div>
  );
}
